
<div class="fx-column" [formGroup]="formGroup">
  <!-- Optional Name and Company if exists -->
  @if (formGroup.get('fullName')) {
    <lc-textbox label="Full Name" lcTestId="full-name" placeholder="" [formControl]="formGroup.get('fullName')" />
  }
  @if (formGroup.get('company')) {
    <lc-textbox 
      lcTestId="company" 
      placeholder="" 
      [formControl]="formGroup.get('company')" 
      [label]="isPrintProduct ? 'Company (Required if shipping to an office address)' : 'Company (Optional)'" />
  }
  <!-- Address -->
  <lc-autocomplete label="Address 1" lcTestId="address-1" placeholder="Number and Street" placeholderText="Number and Street" [autoCompleteOptions]="addressOptions$ | async"  [formControl]="getControl('streetAddress1')" [isAutocomplete]="true" (optionValue)="updateAddressFields($event)" />

  <!-- Street Address2 and City Row -->
  <lc-textbox label="Address 2 (Optional)" lcTestId="address-2" placeholder="Address line 2" [formControl]="getControl('streetAddress2')" />
  <lc-textbox label="City" lcTestId="city" placeholder="City" [formControl]="getControl('city')" />

  <!-- State and Zip Code row (column if layout is xs)-->
  <div lcClass.gt-sm="fx-row-row fx-gap-sm" lcClass.lt-md="fx-column">
    <lc-dropdown class="state" displayPath="abbreviation" emptyOptionDisplay="Select State" label="State" lcClass.gt-sm="fx-1-1-0" lcTestId="state" placeholder="State" valuePath="abbreviation" [formControl]="getControl('state')" [options]="getStates()" />
    <lc-textbox label="Zip Code" lcClass.gt-sm="fx-1-1-0" lcTestId="zip-code" placeholder="Zip Code" [formControl]="getControl('postalCode')" />
  </div>

  @if (formGroup.get('phoneNumber') || formGroup.get('email')) {
    <div lcClass.gt-sm="fx-row fx-gap-md" lcClass.lt-md="fx-column">
      @if (formGroup.get('phoneNumber'); as phoneNumberForm) {
        <ng-container [formGroup]="phoneNumberForm">
          <lc-phone-number class="fx-1-1" idPrefix="phone" label="Phone" lcTestId="phone" [formControl]="phoneNumberForm.get('number')" />
        </ng-container>
      }
      @if (formGroup.get('email'); as emailControl) {
        <lc-textbox class="fx-1-1" idPrefix="email" label="Email (Optional)" lcTestId="email" [formControl]="emailControl" />
      }
    </div>
  }
</div>
